import { FC } from 'react';
import { Rating } from '@mui/material';
import GoogleAvatar from './GoogleAvatar';
import './styles.scss';

interface IProps {
  user: string;
  description: string;
  image: string;
  title: string;
}

const ReviewCard: FC<IProps> = ({ user, description, image, title }) => {
  return (
    <div className='review-card'>
      <div className='review-card__header'>
        <GoogleAvatar name={user} />
        <div className='review-card__header__main'>
          <div className='review-card__header__main__rating'>
            <Rating value={4.9} readOnly />
            <span className='review-card__header__main__rating__text'> 4.9</span>
          </div>
          <div className='review-card__header__main__rating__user'>{user}</div>
        </div>
        <img src='images/google.png' alt='google' loading='lazy' width='30px' />
      </div>
      <div className='review-card__description'>{description}</div>
      <div>
        <img src={image} alt='van' loading='lazy' width='100%' />
        <div className='review-card__van'>{title}</div>
      </div>
    </div>
  );
};
export default ReviewCard;
